import { getFontEmbedCSS, toCanvas } from 'html-to-image/lib';

import * as EscPos from './escpos';

/**
 * Lucrarea de printare directa pentru etichetele din pagina: fiecare eticheta
 * se randeaza exact ca in previzualizare, la rezolutia capului termic, si se
 * codeaza ESC/POS. Macheta ramane una singura - cea din HTML.
 *
 * Se importa `html-to-image/lib` (ES5): varianta implicita, `es/`, foloseste
 * sintaxa pe care webpack 3 nu o poate citi.
 */

/** Pixeli CSS (96 pe inch) -> punctele capului (203 dpi). */
const PIXEL_RATIO = (EscPos.DOTS_PER_MM * 25.4) / 96;

/** Spatiul lasat intre etichete pe hartia continua: 3 mm. */
const CONTINUOUS_GAP_DOTS = 3 * EscPos.DOTS_PER_MM;

export interface LabelPrintOptions {
    /** Rola are etichete separate, iar imprimanta avanseaza pana la urmatoarea. */
    labelRoll: boolean;
    /** Deplasarea fata de centrul capului, in mm; pozitiv inseamna spre dreapta. */
    offsetXMm: number;
    /**
     * Banda de sus pe care imprimanta n-o poate printa pe o rola cu etichete:
     * capul porneste deja atat de jos. Se taie din marginea alba a desenului,
     * care e cel putin la fel de mare.
     */
    deadZoneMm: number;
}

async function renderLabel(
    label: HTMLElement,
    fontEmbedCSS: string,
): Promise<ImageData> {
    const canvas = await toCanvas(label, {
        pixelRatio: PIXEL_RATIO,
        backgroundColor: '#fff',
        fontEmbedCSS,
    });
    const context = canvas.getContext('2d') as CanvasRenderingContext2D;

    return context.getImageData(0, 0, canvas.width, canvas.height);
}

export async function buildLabelJob(
    labels: HTMLElement[],
    options: LabelPrintOptions,
): Promise<Uint8Array> {
    // Fonturile se incorporeaza o singura data, nu la fiecare eticheta.
    const fontEmbedCSS = labels.length ? await getFontEmbedCSS(labels[0]) : '';
    const parts: number[][] = [EscPos.INITIALIZE];

    for (const label of labels) {
        const image = await renderLabel(label, fontEmbedCSS);
        const offsetX =
            (EscPos.HEAD_WIDTH_DOTS - image.width) / 2 +
            options.offsetXMm * EscPos.DOTS_PER_MM;
        const offsetY = options.labelRoll
            ? -options.deadZoneMm * EscPos.DOTS_PER_MM
            : 0;

        parts.push(
            EscPos.encodeImage(image, {
                offsetX,
                offsetY,
                wholeBands: options.labelRoll,
            }),
        );
        parts.push(
            options.labelRoll
                ? EscPos.FEED_TO_NEXT_LABEL
                : EscPos.feedDots(CONTINUOUS_GAP_DOTS),
        );
    }

    if (!options.labelRoll) parts.push(EscPos.feedLines(4));

    return EscPos.concat(parts);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/utils/label-print.ts